var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vh1jru0hqa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lg4biw6gpb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -683) translate(0 668) translate(23 15)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M24.982 16.66c-.87-.765-1.925-1.425-3.135-1.963-.518-.23-1.124.003-1.353.52-.23.517.003 1.123.52 1.353 1.021.454 1.9 1.002 2.615 1.63.88.772 1.384 1.892 1.384 3.072v1.896c0 .565-.46 1.025-1.025 1.025H3.896c-.566 0-1.026-.46-1.026-1.025v-1.896c0-1.18.505-2.3 1.385-3.073 1.036-.91 4.054-3.027 9.687-3.027 4.183 0 7.586-3.403 7.586-7.586S18.125 0 13.942 0 6.356 3.403 6.356 7.586c0 2.445 1.163 4.624 2.965 6.012-3.297.725-5.348 2.12-6.42 3.061-1.322 1.162-2.08 2.843-2.08 4.613v1.896c0 1.696 1.379 3.076 3.075 3.076h20.092c1.696 0 3.076-1.38 3.076-3.076v-1.896c0-1.77-.76-3.45-2.082-4.613zM8.406 7.585c0-3.052 2.484-5.536 5.536-5.536 3.052 0 5.536 2.484 5.536 5.536 0 3.052-2.484 5.536-5.536 5.536-3.052 0-5.536-2.484-5.536-5.536z",
    transform: "translate(2.47 1.698)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lg4biw6gpb)",
    transform: "translate(-23 -683) translate(0 668) translate(23 15) translate(23.182 2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M13.439 8.887c-.468-.408-1.035-.76-1.687-1.047-.278-.123-.604.002-.728.278-.123.276.002.599.28.722.55.242 1.023.534 1.407.869.473.412.745 1.01.745 1.639v1.011c0 .302-.248.547-.552.547H2.096c-.304 0-.552-.245-.552-.547v-1.011c0-.63.272-1.227.745-1.64.557-.485 2.18-1.614 5.211-1.614 2.25 0 4.08-1.816 4.08-4.047C11.58 1.815 9.75 0 7.5 0S3.42 1.815 3.42 4.047c0 1.304.625 2.466 1.594 3.207-1.773.387-2.877 1.13-3.453 1.633-.712.62-1.12 1.517-1.12 2.46v1.012c0 .905.742 1.641 1.655 1.641h10.808c.913 0 1.655-.736 1.655-1.64v-1.012c0-.944-.408-1.84-1.12-2.461zm-8.917-4.84c0-1.628 1.336-2.953 2.978-2.953 1.642 0 2.978 1.325 2.978 2.953S9.142 7 7.5 7C5.858 7 4.522 5.675 4.522 4.047z",
    transform: "translate(.818)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.e4adda0835145fe35605492f12370d3d.svg";
export { ForwardRef as ReactComponent };